import { Button, TextInput, Section, Heading } from '@carbon/react';
import { useState } from 'react';
import { useFetcher } from 'react-router';

export default function TestFacebookSimpleDate() {
  const [startDate, setStartDate] = useState('2024-01-01');
  const [endDate, setEndDate] = useState('2024-12-31');
  const [limit, setLimit] = useState('10');
  const fetcher = useFetcher();

  const handleTest = () => {
    const params = new URLSearchParams({
      startDate,
      endDate,
      limit,
    });
    
    fetcher.load(`/api/facebook-posts-simple?${params}`);
  };

  return (
    <div className="p-6">
      <Section>
        <Heading>Test Facebook Simple Date Filtering</Heading>
        
        <div className="grid grid-cols-3 gap-4 mb-4">
          <TextInput
            id="startDate"
            labelText="Start Date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            type="date"
          />
          <TextInput
            id="endDate"
            labelText="End Date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            type="date"
          />
          <TextInput
            id="limit"
            labelText="Limit"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            type="number"
          />
        </div>
        
        <Button onClick={handleTest} disabled={fetcher.state === 'loading'}>
          {fetcher.state === 'loading' ? 'Testing...' : 'Test Facebook API'}
        </Button>

        {fetcher.data && (
          <div className="mt-6">
            <h3 className="text-lg font-semibold mb-4">Results:</h3>
            
            {fetcher.data.error ? (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                <strong>Error:</strong> {fetcher.data.error}
                <br />
                <strong>Details:</strong> {JSON.stringify(fetcher.data.details)}
              </div>
            ) : (
              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
                <p><strong>Success!</strong> Found {fetcher.data.posts?.length} posts</p>
                <p><strong>Date Range:</strong> {fetcher.data.metadata?.dateRange?.startDate} to {fetcher.data.metadata?.dateRange?.endDate}</p>
                <p><strong>Fetched At:</strong> {fetcher.data.metadata?.fetchedAt}</p>
                
                <div className="mt-4">
                  <h4 className="font-semibold">Posts:</h4>
                  <div className="max-h-96 overflow-y-auto">
                    {fetcher.data.posts?.map((post: any) => (
                      <div key={post.id} className="border-l-4 border-blue-500 pl-4 py-2 mb-2">
                        <p><strong>ID:</strong> {post.id}</p>
                        <p><strong>Created:</strong> {new Date(post.created_time).toLocaleString()}</p>
                        {post.message && <p><strong>Message:</strong> {post.message.substring(0, 100)}...</p>}
                        {post.insights && (
                          <div className="text-sm">
                            <strong>Insights:</strong> 
                            {post.insights.impressions && ` Impressions: ${post.insights.impressions}`}
                            {post.insights.reach && ` Reach: ${post.insights.reach}`}
                            {post.insights.video_views && ` Video Views: ${post.insights.video_views}`}
                          </div>
                        )}
                        {post.permalink_url && (
                          <a 
                            href={post.permalink_url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:underline text-sm"
                          >
                            View Post
                          </a>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </Section>
    </div>
  );
}